
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Board, Card, CardAttributeDefinition } from '../../../../backend/backendapi';
import { KanbanState } from '../../../kanban.model';
import { SystemAttributes } from '../modal/attributes.model';
import { WindowType } from '../../../../../util';
import ActivityAttribute from './systemattribute/ActivityAttribute';
import CellAttribute from './systemattribute/CellAttribute';
import SurveyResultAttribute from '../../SurveyResultAttribute';
import Attribute from './attribute/Attribute';

declare var window: WindowType;

@Component({
  components: {
    Attribute,
    ActivityAttribute,
    CellAttribute,
    SurveyResultAttribute,
  },
})
export default class AttributeDisplay extends Vue {
  @Prop({ required: true })
  readonly state!: KanbanState;
  @Prop({ required: true })
  readonly board!: Board;
  @Prop({ required: true })
  readonly card!: Card;

  get canActivity(): boolean {
    return window.application.permissions.activity.activity;
  }

  get definitions(): CardAttributeDefinition[] {
    return this.board.attributeDefinitions ?? [];
  }

  get systemAttributes(): SystemAttributes {
    let ret = new SystemAttributes();
    ret.cellId = this.card.cellId;
    ret.activityId = this.card.activityId;
    return ret;
  }
}
